export const LANGUAGES = {
  EN: 'english',
  HE: 'hebrew',
};
